// Bootstrap's md entry in $grid-breakpoints.
export const MD_BREAKPOINT = 768;
// Mirrors media-breakpoint-down(md), which subtracts 0.02px to avoid overlapping min-width: 768px.
export const MOBILE_MEDIA_QUERY = `(max-width: ${MD_BREAKPOINT - 0.02}px)`;
